import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Check, Minus } from "lucide-react";

const CustomCheckbox = ({ checked, onChange, indeterminate = false, label, disabled = false, ...props }) => {
  const classes = useStyles();
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <label className={`${classes.root} ${disabled ? classes.disabled : ""}`} {...props}>
      <input type="checkbox" ref={checkboxRef} checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} className={classes.srOnly} />
      <span className={`${classes.checkbox} ${checked || indeterminate ? classes.checked : ""}`}>
        {indeterminate ? <Minus className={classes.checkbox__icon} /> : checked ? <Check className={classes.checkbox__icon} /> : null}
      </span>
      {label && <span className={classes.label}>{label}</span>}
    </label>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none",
    paddingRight: 16,
  },
  checkbox: {
    width: 16,
    height: 16,
    border: "1px solid #0C0E29",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
  },
  checked: {
    backgroundColor: "var(--color-primary)",
    borderColor: "var(--color-primary)",
    color: "#F8F8F8",
  },
  disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  checkbox__icon: {
    width: 12,
    height: 12,
    strokeWidth: 2,
    color: "#F8F8F8",
  },
  label: {
    marginLeft: 8,
    fontSize: 14,
    color: "#0C0E29",
    fontFamily: "Lato",
  },
  srOnly: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
  },
}));

export default CustomCheckbox;
